import { action, makeAutoObservable } from "mobx"; 
import { RelatedItemsCategoriesModel, RelatedSectionModel } from "../models/DonationAndItemModel";

export default class RelatedItemsService {
  public relatedSectionData: RelatedSectionModel;
  public categories: RelatedItemsCategoriesModel[];
  constructor() {
    this.relatedSectionData = new RelatedSectionModel();
    this.categories = [];
    makeAutoObservable(this);
  }

  @action addNewCategory(category: RelatedItemsCategoriesModel) {
    const clone = this.categories.map((c) => {
      return new RelatedItemsCategoriesModel(c);
    });

    clone.push(category);
    this.categories = clone;
  }

  update(data: RelatedSectionModel) {
    this.relatedSectionData = new RelatedSectionModel(data);
  }
}
